// Dynamic configuration based on domain
export const getConfig = () => {
  const hostname = window.location.hostname;

  // Production domains
  const isProduction = hostname === 'portal.reziland.ca';

  // Localhost development
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isProduction) {
    return {
      API_BASE_URL: 'https://api.reziland.ca',
      ENVIRONMENT: 'production'
    };
  } else if (isLocalhost) {
    return {
      API_BASE_URL: 'http://localhost:37567',
      ENVIRONMENT: 'localhost'
    };
  } else {
    // Development domains: portal-develop.reziland.ca, or any other domain
    return {
      API_BASE_URL: 'https://api-develop.reziland.ca',
      ENVIRONMENT: 'develop'
    };
  }
};

// Google OAuth Web Client ID (same across environments — public value)
export const GOOGLE_CLIENT_ID = '1003431167399-ou5fghf7uoue4ptu2obbddmqn5ao7qlm.apps.googleusercontent.com';

// Helper to get specific config values
export const getApiBaseUrl = () => getConfig().API_BASE_URL;
export const getEnvironment = () => getConfig().ENVIRONMENT;
